import React, { useState, useEffect, useRef } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import { C } from './constants';

// ─────────────────────────────────────────────────────────────────────────────
// 🔄 MISE À JOUR DU CATALOGUE DEPUIS MIHI.CARE (sans mot de passe)
// 1) Sur mihi.care (déjà connectée), un raccourci lit les pages catégories et copie les produits.
// 2) Ici, on colle : l'app compare avec le catalogue, montre ce qui change, puis applique.
// Règle des prix : prix catalogue (celui que paie une cliente) = « prix » ET « prixCatalogue »,
// prix VIP (Premium Club) = 70 % du prix catalogue. Les noms/images/offres existants ne sont pas touchés.
// Une copie de sécurité de l'ancien catalogue est gardée pour pouvoir annuler.
// ─────────────────────────────────────────────────────────────────────────────

const SCHEMA = 'java' + 'script:';
export const RACCOURCI_CODE = "(async function(){try{if(!/(^|\\.)mihi\\.care$/.test(location.hostname)){alert(\"Ouvre d'abord mihi.care (connect\\xE9e \\xE0 ton compte), puis relance ce raccourci.\");return}var w=document.getElementById(\"bd-maj-catalogue\");w&&w.remove();var i=document.createElement(\"div\");i.id=\"bd-maj-catalogue\",i.style.cssText=\"position:fixed;z-index:2147483647;left:0;right:0;top:12vh;margin:0 auto;width:min(520px,92vw);display:flex;flex-direction:column;background:#fff;color:#3D1F0E;border-radius:16px;box-shadow:0 10px 40px rgba(0,0,0,.35);padding:18px;font:14px/1.45 Arial,sans-serif\",i.innerHTML='<div style=\"font-weight:700;font-size:16px;margin-bottom:6px\">Blazing Dynasty : lecture du catalogue</div><div id=\"bd-etat\">D\\xE9marrage\\u2026</div>',document.body.appendChild(i);var g=function(e){var t=document.getElementById(\"bd-etat\");t&&(t.textContent=e)},E=function(e){return e.replace(/&#0?39;/g,\"'\").replace(/&quot;/g,'\"').replace(/&lt;/g,\"<\").replace(/&gt;/g,\">\").replace(/&amp;/g,\"&\")},I=function(e){return new Promise(function(t){setTimeout(t,e)})},a=Array.from(new Set(Array.from(document.querySelectorAll(\"a[href]\")).map(function(e){return e.pathname}).filter(function(e){return/^\\/c-/.test(e)})));if(!a.length){g(\"Je ne trouve pas les cat\\xE9gories : ouvre la page d'accueil de mihi.care et relance.\");return}for(var T=[[134,\"Sant\\xE9 f\\xE9minine\"],[135,\"Sant\\xE9 masculine\"],[133,\"Soutien de l'immunit\\xE9\"],[136,\"Sant\\xE9 du c\\u0153ur\"],[137,\"Syst\\xE8me digestif\"],[138,\"Sommeil et relaxation\"],[139,\"\\xC9nergie et vitalit\\xE9\"],[140,\"M\\xE9moire et sant\\xE9 c\\xE9r\\xE9brale\"],[141,\"Os\"],[142,\"Articulations\"],[143,\"Sant\\xE9 des yeux\"],[144,\"Peau, cheveux et ongles\"],[145,\"Contr\\xF4le du poids & d\\xE9tox\"],[146,\"Vieillissement en bonne sant\\xE9\"],[148,\"Antioxydants\"],[147,\"Vitamines et min\\xE9raux\"]],m={},r=[],o=0;o<a.length;o++){g(\"Cat\\xE9gorie \"+(o+1)+\" sur \"+a.length+\" \\u2026 (\"+Object.keys(m).length+\" produits)\");var z=await fetch(a[o],{credentials:\"same-origin\"}),_=await z.text(),k=_.match(/:products-prop='(\\[[\\s\\S]*?\\])'\\s/),b=a[o].slice(3);if(k){var s;try{s=JSON.parse(E(k[1]))}catch{continue}s[0]&&s[0].category_slug&&(b=s[0].category_slug),s.forEach(function(e){if(!(!e||!e.sku)){var t=e.descriptions||[],u=t.filter(function(y){return y.language_key===\"fr\"})[0]||t[0]||{},l=Number(e.converted_user_price);l>0&&(m[e.sku]={r:String(e.sku),n:(e.seria?e.seria+\". \":\"\")+(u.name||\"\"),p:l,v:Number(e.new_price)>0?Number(e.new_price):0,a:Number(e.converted_marketing_price)||0,s:e.availability,q:e.quantity,i:(e.images||[])[0]||\"\",c:e.category_slug||a[o].slice(3)})}})}try{var A=_.match(/:category='(\\{[\\s\\S]*?\\})'(?=\\s+:|\\s*>)/);if(A){var c=JSON.parse(E(A[1]));if(c&&c.id!=null&&Array.isArray(c.children)&&c.children.length){var C=b===\"health\",J=c.children.filter(function(e){return e&&e.id!=null&&e.slug}).map(function(e){var t=e.descriptions||[],u=t.filter(function(l){return l.language_key===\"fr\"})[0]||t[0]||{};return{id:e.id,s:e.slug,n:u.name||e.slug,g:C?\"Type de produit\":\"\",r:[]}}),M=C?T.map(function(e){return{id:e[0],s:\"besoin-\"+e[0],n:e[1],g:\"Selon ton besoin\",r:[]}}):[];r.push({c:b,id:c.id,e:M.concat(J)})}}}catch{}}var v=Object.keys(m).map(function(e){return m[e]});if(v.length<50){g(\"Seulement \"+v.length+\" produits trouv\\xE9s : \\xE7a ressemble \\xE0 un probl\\xE8me (connexion ?). Rien \\xE0 copier.\");return}var O=0,N=0,q=0;r.forEach(function(e){O+=e.e.length});for(var d=0;d<r.length;d++)for(var x=0;x<r[d].e.length;x++){var p=r[d].e[x];N++,g(\"Sous-cat\\xE9gories \"+N+\" sur \"+O+\" \\u2026 (\"+p.n+\")\");try{var B={},f=1,h=1;do{var F=await fetch(\"/api/products?category_id=\"+r[d].id+\"&promo=0&categories[]=\"+p.id+\"&lang=fr\"+(f>1?\"&page=\"+f:\"\"),{credentials:\"same-origin\",headers:{Accept:\"application/json\",\"X-Requested-With\":\"XMLHttpRequest\"}}),n=JSON.parse(await F.text()),H=(function e(t,u){if(!t||u>4)return null;if(Array.isArray(t))return t.length&&t[0]&&t[0].sku!=null||!t.length?t:null;if(typeof t==\"object\")for(var l in t){var y=e(t[l],u+1);if(y)return y}return null})(n,0)||[];H.forEach(function(e){B[String(e.sku)]=1}),h=1,[n.products,n.products&&n.products.meta,n.meta,n.data,n].forEach(function(e){h===1&&e&&typeof e==\"object\"&&Number(e.last_page)>1&&(h=Number(e.last_page))}),f++}while(f<=h&&f<=8);p.r=Object.keys(B),p.r.length&&q++}catch{p.r=[]}await I(120)}var L=r.map(function(e){return{c:e.c,e:e.e.filter(function(t){return t.r.length}).map(function(t){return t.g?{s:t.s,n:t.n,g:t.g,r:t.r}:{s:t.s,n:t.n,r:t.r}})}}).filter(function(e){return e.e.length}),D=JSON.stringify({bd:\"catalogue-mihi\",version:2,date:new Date().toISOString(),produits:v,sc:L});i.innerHTML='<div style=\"font-weight:700;font-size:16px;margin-bottom:6px\">\\u2705 '+v.length+' produits lus sur mihi.care</div><div style=\"margin-bottom:8px\">'+q+' sous-cat\\xE9gories lues. Clique sur \\xAB Copier \\xBB, puis va dans ton app : Espace Chef \\u2192 Catalogue \\u2192 \\xAB Mise \\xE0 jour depuis mihi.care \\xBB et colle.</div><textarea id=\"bd-texte\" readonly style=\"align-self:stretch;height:90px;font:11px monospace;border:1px solid #ccc;border-radius:8px;padding:6px;box-sizing:border-box\"></textarea><div style=\"display:flex;gap:8px;margin-top:10px\"><button id=\"bd-copier\" style=\"flex:1;padding:10px;border:0;border-radius:10px;background:#3D1F0E;color:#fff;font-weight:700;cursor:pointer\">Copier</button><button id=\"bd-fermer\" style=\"padding:10px 14px;border:1px solid #ccc;border-radius:10px;background:#fff;cursor:pointer\">Fermer</button></div><div id=\"bd-ok\" style=\"margin-top:8px;color:#2D5A3D;font-weight:700\"></div>';var S=document.getElementById(\"bd-texte\");S.value=D,document.getElementById(\"bd-fermer\").onclick=function(){i.remove()},document.getElementById(\"bd-copier\").onclick=async function(){var e=!1;try{await navigator.clipboard.writeText(D),e=!0}catch{}if(!e){S.focus(),S.select();try{e=document.execCommand(\"copy\")}catch{}}document.getElementById(\"bd-ok\").textContent=e?\"Copi\\xE9 ! Tu peux coller dans l'app.\":\"S\\xE9lectionne le texte et copie-le (Ctrl+C).\"}}catch(e){alert(\"Oups, la lecture a \\xE9chou\\xE9 : \"+(e&&e.message?e.message:e))}})();";

const SLUG_VERS_CAT = {
  'face': 'face', 'body': 'corps', 'hair': 'hair', 'make-up': 'makeup', 'perfume': 'parfums',
  'health': 'health', 'man': 'hommes', 'baby': 'enfants', 'home': 'home', 'sets': 'sets',
  'weight-control': 'nutrition',
};
const CAT_LIBELLE = {
  face: 'VISAGE', corps: 'CORPS', hair: 'CHEVEUX', makeup: 'Make Up', parfums: 'PARFUMS', health: 'SANTÉ',
  hommes: 'Hommes', enfants: 'Enfants', home: 'HOME', sets: 'Sets', nutrition: 'Nutrition',
};
const BASE_IMAGES = 'https://www.mihi.care/storage/mini/';

const sansZeros = (r) => String(r == null ? '' : r).trim().replace(/^0+/, '');
const arrondi2 = (n) => Math.round(n * 100) / 100;
const fmt = (n) => (typeof n === 'number' && isFinite(n) ? n.toFixed(2).replace('.', ',') + ' €' : '—');

// Sous-catégories officielles de mihi.care (Yeux, Lèvres, Gels douche, Sommeil…) : relevé du favori -> document lu par la boutique
const NOMS_PROPRES = {
  'make-up-brows': 'Sourcils', 'make-up-face': 'Teint', 'hair-hair-sonditioners-balms': 'Après-shampooings et baumes',
  'hair-scalp-peelings': 'Gommages du cuir chevelu', 'home-laundry-gels': 'Lessives', 'home-fabric-softeners': 'Adoucissants',
  'health-balms': 'Baumes', 'health-creams': 'Crèmes', 'health-gels': 'Gels', 'health-sprays': 'Sprays', 'food': 'Alimentation',
  'body-stretch-mark-creams': 'Brumes pour le corps', 'baby-toothpastes': 'Dentifrices'
};
export function construireSousCategories(paquet) {
  const categories = {};
  ((paquet && paquet.sc) || []).forEach((k) => {
    const cat = SLUG_VERS_CAT[k && k.c];
    if (!cat || !Array.isArray(k.e)) return;
    const liste = k.e.filter((e) => e && e.s && Array.isArray(e.r) && e.r.length).map((e) => {
      const nom = NOMS_PROPRES[e.s] || String(e.n || e.s).replace(/\u0441/g, 'c').replace(/\u0421/g, 'C').replace(/\s+/g, ' ').trim();
      const sortie = { slug: String(e.s), nom, refs: Array.from(new Set(e.r.map((r) => String(r)))) };
      if (e.g) sortie.g = String(e.g);
      return sortie;
    });
    if (liste.length) categories[cat] = liste;
  });
  return { date: (paquet && paquet.date) || new Date().toISOString(), categories };
}

export function lirePaquet(texte) {
  let data;
  try { data = JSON.parse(String(texte || '').trim()); } catch (e) { throw new Error("Ce texte n'est pas celui du raccourci. Recopie-le en entier (bouton « Copier » sur mihi.care)."); }
  if (data && data.bd === 'equipe-mihi') throw new Error("Ce texte vient du favori « Lire mon équipe Mihi ». Pour le catalogue, clique plutôt sur le favori « Lire le catalogue Mihi » sur mihi.care. Et ce texte-ci se colle dans la case des chiffres de l'équipe.");
  if (!data || data.bd !== 'catalogue-mihi' || !Array.isArray(data.produits)) throw new Error("Ce n'est pas le contenu du raccourci Blazing Dynasty.");
  const produits = data.produits.filter((p) => p && p.r && Number(p.p) > 0);
  if (produits.length < 50) throw new Error('Seulement ' + produits.length + ' produits dans ce texte : il manque une partie. Relance le raccourci sur mihi.care.');
  return { date: data.date || '', produits, sc: Array.isArray(data.sc) ? data.sc : [] };
}

// Compare le catalogue actuel (admin/catalogue_mihi) avec le relevé mihi.care, sans rien écrire.
export function fusionnerCatalogue(actuel, paquet, { ajouterNouveaux = true } = {}) {
  const catalogue = {};
  Object.keys(actuel || {}).forEach((k) => { catalogue[k] = Array.isArray(actuel[k]) ? actuel[k].map((x) => ({ ...x })) : actuel[k]; });
  const index = {};
  Object.keys(catalogue).forEach((k) => {
    if (!Array.isArray(catalogue[k])) return;
    catalogue[k].forEach((it, i) => { if (it && it.ref != null) index[sansZeros(it.ref)] = { cat: k, i }; });
  });
  const rapport = { modifies: [], inchanges: 0, nouveaux: [], horsCategorie: [], absents: [], dejaRetires: 0, presents: [], total: paquet.produits.length };
  const vus = new Set();
  paquet.produits.forEach((p) => {
    const ref = sansZeros(p.r);
    if (!ref || vus.has(ref)) return;
    vus.add(ref);
    const prix = arrondi2(Number(p.p));
    const vip = arrondi2(Math.round(prix * 70) / 100);
    const rupture = !(Number(p.s) > 0 && Number(p.q) > 0);
    const place = index[ref];
    if (place) {
      const ancien = catalogue[place.cat][place.i];
      const avant = Number(ancien.prixCatalogue) > 0 ? Number(ancien.prixCatalogue) : Number(ancien.prix);
      rapport.presents.push({ ref, nom: ancien.nom, prix, cat: place.cat });
      const neuf = { ...ancien, prix, prixCatalogue: prix, prixVIP: vip, rupture };
      delete neuf.retireMihi;   // le produit est de nouveau sur mihi.care
      if (!ancien.image && p.i) neuf.image = BASE_IMAGES + String(p.i).replace(/^\/+/, '');
      const change = Math.abs(avant - prix) > 0.004 || Math.abs(Number(ancien.prix) - prix) > 0.004 || Math.abs(Number(ancien.prixVIP || 0) - vip) > 0.004 || !!ancien.rupture !== rupture;
      if (change) {
        rapport.modifies.push({ ref, nom: ancien.nom, avant, apres: prix, rupture, ancienneRupture: !!ancien.rupture, gros: avant > 0 && (prix / avant > 1.4 || prix / avant < 0.6) });
      } else rapport.inchanges++;
      catalogue[place.cat][place.i] = neuf;
    } else {
      const cat = SLUG_VERS_CAT[p.c];
      if (!cat) { rapport.horsCategorie.push({ ref, nom: p.n }); return; }
      rapport.nouveaux.push({ ref, nom: p.n, prix, cat });
      if (ajouterNouveaux) {
        if (!Array.isArray(catalogue[cat])) catalogue[cat] = [];
        catalogue[cat].push({
          nom: String(p.n || ''), prix, ref, serie: CAT_LIBELLE[cat] || cat, offre: '', prixOffre: '',
          prixVIP: vip, prixCatalogue: prix, image: p.i ? BASE_IMAGES + String(p.i).replace(/^\/+/, '') : '', rupture,
        });
      }
    }
  });
  Object.keys(index).forEach((ref) => {
    if (!vus.has(ref)) {
      const { cat, i } = index[ref];
      const it = actuel[cat][i] || {};
      if (it.retireMihi) { rapport.dejaRetires++; return; }
      rapport.absents.push({ ref, nom: it.nom, cat: it.serie || CAT_LIBELLE[cat] || cat, prix: Number(it.prixCatalogue) > 0 ? Number(it.prixCatalogue) : Number(it.prix) || 0 });
    }
  });
  return { catalogue, rapport };
}

const boite = { background: C.blanc, border: `1px solid ${C.pale}`, borderRadius: 12, padding: '1rem', marginBottom: '1.25rem' };
const titre = { fontSize: '.62rem', fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: C.rose, marginBottom: '.6rem' };
const bouton = (actif = true, fond = C.brun) => ({ display: 'block', width: '100%', background: actif ? fond : C.pale, color: 'white', border: 'none', borderRadius: 9, padding: '.55rem', textAlign: 'center', fontSize: '.78rem', fontWeight: 600, cursor: actif ? 'pointer' : 'default', fontFamily: 'inherit' });

// Marque des produits « indisponibles » (ils ne peuvent plus être commandés dans la boutique). Une copie de l'ancien catalogue est gardée.
export async function marquerIndisponibles(refs) {
  const voulues = new Set((refs || []).map(sansZeros));
  const snap = await getDoc(doc(db, 'admin', 'catalogue_mihi'));
  if (!snap.exists()) throw new Error("Le catalogue n'existe pas encore.");
  const actuel = snap.data();
  const neuf = {};
  let n = 0;
  Object.keys(actuel).forEach((k) => {
    neuf[k] = Array.isArray(actuel[k]) ? actuel[k].map((it) => {
      if (it && it.ref != null && voulues.has(sansZeros(it.ref))) { n++; return { ...it, rupture: true, retireMihi: true }; }
      return it;
    }) : actuel[k];
  });
  if (!n) return 0;
  await setDoc(doc(db, 'admin', 'catalogue_mihi_avant'), actuel);
  await setDoc(doc(db, 'admin', 'catalogue_mihi'), neuf);
  return n;
}

// Nom comparable : sans accents, sans ponctuation, sans mots vides
const MOTS_VIDES = new Set(['de', 'du', 'des', 'la', 'le', 'les', 'et', 'a', 'au', 'aux', 'pour', 'en', 'ml', 'g', 'gr', 'mg', 'x']);
const jetonsNom = (t) => String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').split(' ').filter((m) => m && !MOTS_VIDES.has(m) && !/^\d+$/.test(m));

// Un produit disparu + un « nouveau » produit qui lui ressemble = probablement le même, avec une nouvelle référence.
// sure = même nom ; sinon proposition (à confirmer). Un nouveau produit n'est proposé qu'une fois.
export function proposerChangementsRef(rapport) {
  const res = [];
  const pris = new Set();
  const absents = (rapport && rapport.absents) || [];
  // 1) les « nouveaux » produits ; 2) ceux déjà ajoutés lors d'une précédente mise à jour (la fiche existe en double : on la fusionnera)
  const candidats = [
    ...((rapport && rapport.nouveaux) || []).map((n) => ({ ...n, doublon: false })),
    ...((rapport && rapport.presents) || []).map((n) => ({ ...n, doublon: true })),
  ];
  absents.forEach((a) => {
    const ja = jetonsNom(a.nom);
    if (!ja.length) return;
    let meilleur = null;
    candidats.forEach((n) => {
      if (pris.has(n.ref)) return;
      const jn = jetonsNom(n.nom);
      if (!jn.length) return;
      const commun = ja.filter((m) => jn.includes(m)).length;
      const score = commun / new Set([...ja, ...jn]).size;
      const identique = ja.join(' ') === jn.join(' ');
      const seuil = n.doublon ? 0.8 : 0.6;     // un produit déjà dans le catalogue : on est plus exigeante
      if ((identique || score >= seuil) && (!meilleur || score > meilleur.score || (score === meilleur.score && meilleur.n.doublon && !n.doublon))) meilleur = { n, score, identique };
    });
    if (meilleur) { pris.add(meilleur.n.ref); res.push({ ancienne: a.ref, nouvelle: meilleur.n.ref, nomAncien: a.nom, nomNouveau: meilleur.n.nom, prixAncien: a.prix, prixNouveau: meilleur.n.prix, sure: meilleur.identique, doublon: meilleur.n.doublon }); }
  });
  return res;
}

// Applique un changement sur le catalogue (copie de sécurité gardée pour « Annuler »).
async function modifierCatalogue(transformer) {
  const snap = await getDoc(doc(db, 'admin', 'catalogue_mihi'));
  if (!snap.exists()) throw new Error("Le catalogue n'existe pas encore.");
  const actuel = snap.data();
  const neuf = {};
  let n = 0;
  Object.keys(actuel).forEach((k) => {
    if (!Array.isArray(actuel[k])) { neuf[k] = actuel[k]; return; }
    neuf[k] = [];
    actuel[k].forEach((it) => {
      const r = it && it.ref != null ? transformer(it) : it;
      if (r === null) { n++; return; }            // supprimé
      if (r !== it) n++;
      neuf[k].push(r);
    });
  });
  if (!n) return 0;
  await setDoc(doc(db, 'admin', 'catalogue_mihi_avant'), actuel);
  await setDoc(doc(db, 'admin', 'catalogue_mihi'), neuf);
  return n;
}
export async function supprimerProduits(refs) {
  const v = new Set((refs || []).map(sansZeros));
  return modifierCatalogue((it) => (v.has(sansZeros(it.ref)) ? null : it));
}
export async function remettreDisponibles(refs) {
  const v = new Set((refs || []).map(sansZeros));
  return modifierCatalogue((it) => {
    if (!v.has(sansZeros(it.ref))) return it;
    const { retireMihi, ...reste } = it;
    return { ...reste, rupture: false };
  });
}
// Garde la fiche (photo, offres, packs) et change seulement la référence. L'ancienne est conservée dans « anciensRefs »
// pour que les packs, best-sellers et favoris qui l'utilisent la retrouvent.
export async function changerReferences(paires) {
  const map = {};
  const doublons = new Set();
  (paires || []).forEach((p) => { map[sansZeros(p.ancienne)] = sansZeros(p.nouvelle); if (p.doublon) doublons.add(sansZeros(p.nouvelle)); });
  const snap = await getDoc(doc(db, 'admin', 'catalogue_mihi'));
  const existantes = new Set();
  if (snap.exists()) Object.values(snap.data()).forEach((l) => Array.isArray(l) && l.forEach((it) => it && it.ref != null && existantes.add(sansZeros(it.ref))));
  return modifierCatalogue((it) => {
    const r = sansZeros(it.ref);
    if (doublons.has(r)) return null;                       // la fiche ajoutée en double disparaît : on garde l'ancienne, avec ta photo et tes offres
    const nouvelle = map[r];
    if (!nouvelle || (existantes.has(nouvelle) && !doublons.has(nouvelle))) return it;
    return { ...it, ref: nouvelle, anciensRefs: [...new Set([...(it.anciensRefs || []), String(it.ref)])] };
  });
}
function produitsRetires(catalogue) {
  const res = [];
  Object.keys(catalogue || {}).forEach((k) => {
    if (!Array.isArray(catalogue[k])) return;
    catalogue[k].forEach((it) => { if (it && it.retireMihi) res.push({ ref: it.ref, nom: it.nom, cat: it.serie || k, prix: Number(it.prixCatalogue) > 0 ? Number(it.prixCatalogue) : Number(it.prix) || 0 }); });
  });
  return res;
}

// Si l'affichage plante, on montre le message au lieu d'une carte qui disparaît
class BoiteErreur extends React.Component {
  constructor(props) { super(props); this.state = { erreur: null }; }
  static getDerivedStateFromError(erreur) { return { erreur }; }
  render() {
    if (!this.state.erreur) return this.props.children;
    return (
      <div style={{ background: '#FDECEC', border: '1px solid #E0A0A0', borderRadius: 10, padding: '.7rem .85rem', fontSize: '.72rem', color: '#8B1A1A', lineHeight: 1.6 }}>
        <strong>Oups, l'affichage a rencontré un souci.</strong> Envoie ce message à ton assistante : <em>{String((this.state.erreur && this.state.erreur.message) || this.state.erreur)}</em>
        <div><button onClick={() => this.setState({ erreur: null })} style={{ marginTop: '.4rem', background: '#8B1A1A', color: 'white', border: 'none', borderRadius: 8, padding: '.35rem .8rem', fontSize: '.7rem', cursor: 'pointer', fontFamily: 'inherit' }}>Réessayer</button></div>
      </div>
    );
  }
}

export function AdminMajCatalogue(props) {
  return <BoiteErreur><AdminMajCatalogueInterne {...props} /></BoiteErreur>;
}

function AdminMajCatalogueInterne({ compact = false }) {
  const [texte, setTexte] = useState('');
  const [analyse, setAnalyse] = useState(null);
  const [ajouter, setAjouter] = useState(true);
  const [message, setMessage] = useState(null);
  const [occupe, setOccupe] = useState(false);
  const [derniere, setDerniere] = useState(null);
  const [peutAnnuler, setPeutAnnuler] = useState(false);
  const [voirAlerte, setVoirAlerte] = useState(false);
  const [coches, setCoches] = useState({});
  const [retires, setRetires] = useState([]);
  const [voirRetires, setVoirRetires] = useState(false);
  const [cochesR, setCochesR] = useState({});
  const [cochesRef, setCochesRef] = useState({});
  const [confirmer, setConfirmer] = useState('');
  const [refEnCours, setRefEnCours] = useState('');
  const [rechercheRef, setRechercheRef] = useState('');
  const [codeCopie, setCodeCopie] = useState(false);
  const lienRef = useRef(null);

  // React refuse les liens « javascript: » dans le JSX : on le pose directement sur l'élément.
  useEffect(() => { if (lienRef.current) lienRef.current.setAttribute('href', SCHEMA + RACCOURCI_CODE); }, []);

  const charger = async () => {
    try {
      const s = await getDoc(doc(db, 'admin', 'catalogue_mihi_maj'));
      if (s.exists()) setDerniere(s.data());
      const b = await getDoc(doc(db, 'admin', 'catalogue_mihi_avant'));
      setPeutAnnuler(b.exists());
    } catch (e) { /* facultatif */ }
  };
  useEffect(() => { charger(); }, []);
  const chargerRetires = async () => {
    try { const c = await getDoc(doc(db, 'admin', 'catalogue_mihi')); setRetires(c.exists() ? produitsRetires(c.data()) : []); } catch (e) { /* facultatif */ }
  };
  useEffect(() => { chargerRetires(); }, []);
  // Après un changement du catalogue : on relit tout, et on refait l'analyse en cours pour repartir de la bonne base
  const rafraichir = async () => {
    const snap = await getDoc(doc(db, 'admin', 'catalogue_mihi'));
    if (snap.exists()) { setRetires(produitsRetires(snap.data())); if (analyse) setAnalyse({ paquet: analyse.paquet, actuel: snap.data() }); }
    setPeutAnnuler(true); setCoches({}); setCochesR({}); setCochesRef({}); setConfirmer('');
  };

  const analyser = async () => {
    setMessage(null); setAnalyse(null); setOccupe(true);
    try {
      const paquet = lirePaquet(texte);
      const snap = await getDoc(doc(db, 'admin', 'catalogue_mihi'));
      if (!snap.exists()) throw new Error("Le catalogue n'existe pas encore : fais d'abord l'import Excel ci-dessus.");
      setAnalyse({ paquet, actuel: snap.data() });
    } catch (e) { setMessage('❌ ' + e.message); }
    setOccupe(false);
  };

  const resultat = analyse ? fusionnerCatalogue(analyse.actuel, analyse.paquet, { ajouterNouveaux: ajouter }) : null;

  const appliquer = async () => {
    if (!resultat) return;
    setOccupe(true); setMessage(null);
    try {
      await setDoc(doc(db, 'admin', 'catalogue_mihi_avant'), analyse.actuel);
      await setDoc(doc(db, 'admin', 'catalogue_mihi'), resultat.catalogue);
      let nbSc = 0;
      try {
        const sc = construireSousCategories(analyse.paquet);
        nbSc = Object.keys(sc.categories).reduce((t, k) => t + sc.categories[k].length, 0);
        if (nbSc) await setDoc(doc(db, 'reglages_publics', 'catalogue_sous_categories'), sc);
      } catch (e) { nbSc = -1; }
      const r = resultat.rapport;
      const info = { date: new Date().toISOString(), modifies: r.modifies.length, nouveaux: ajouter ? r.nouveaux.length : 0, total: r.total, absents: r.absents.slice(0, 300) };
      try { await setDoc(doc(db, 'admin', 'catalogue_mihi_maj'), info); setDerniere(info); } catch (e) { /* facultatif */ }
      setPeutAnnuler(true); setAnalyse(null); setTexte('');
      setMessage('✅ Catalogue mis à jour : ' + r.modifies.length + ' produit(s) modifié(s)' + (ajouter && r.nouveaux.length ? ', ' + r.nouveaux.length + ' ajouté(s)' : '') + '.' + (nbSc > 0 ? ' ' + nbSc + ' sous-catégories mises à jour pour la boutique.' : nbSc < 0 ? " Les sous-catégories n'ont pas pu être enregistrées." : ''));
    } catch (e) { setMessage('❌ Erreur : ' + e.message); }
    setOccupe(false);
  };

  const rAnalyse = analyse ? fusionnerCatalogue(analyse.actuel, analyse.paquet, { ajouterNouveaux: false }).rapport : null;
  const enAnalyse = !!rAnalyse;
  const avecSc = !!(analyse && analyse.paquet && Array.isArray(analyse.paquet.sc) && analyse.paquet.sc.length);
  const alerte = enAnalyse ? rAnalyse.absents : ((derniere && Array.isArray(derniere.absents)) ? derniere.absents : []);
  const nbCoches = alerte.filter((a) => coches[a.ref]).length;
  const retirerDeLAlerte = async (refs) => {
    const reste = alerte.filter((a) => !refs.includes(a.ref));
    const info = { ...derniere, absents: reste };
    try { await setDoc(doc(db, 'admin', 'catalogue_mihi_maj'), info); } catch (e) { /* facultatif */ }
    setDerniere(info); setCoches({});
  };
  const marquerCoches = async () => {
    const refs = alerte.filter((a) => coches[a.ref]).map((a) => a.ref);
    if (!refs.length) return;
    setOccupe(true); setMessage(null);
    try {
      const n = await marquerIndisponibles(refs);
      if (!enAnalyse) await retirerDeLAlerte(refs);
      await rafraichir();
      setMessage('✅ ' + n + ' produit(s) marqué(s) indisponible(s) dans la boutique. Tu peux annuler avec le bouton « Annuler la dernière mise à jour ».');
    } catch (e) { setMessage('❌ Erreur : ' + e.message); }
    setOccupe(false);
  };
  const supprimerCoches = async () => {
    const refs = alerte.filter((a) => coches[a.ref]).map((a) => a.ref);
    if (!refs.length) return;
    setOccupe(true); setMessage(null);
    try {
      const n = await supprimerProduits(refs);
      if (!enAnalyse) await retirerDeLAlerte(refs);
      await rafraichir();
      setMessage('🗑️ ' + n + ' produit(s) supprimé(s) du catalogue. Tu peux annuler avec le bouton « Annuler la dernière mise à jour ».');
    } catch (e) { setMessage('❌ Erreur : ' + e.message); }
    setOccupe(false);
  };
  const agirSurRetires = async (action) => {
    const refs = retires.filter((a) => cochesR[a.ref]).map((a) => a.ref);
    if (!refs.length) return;
    setOccupe(true); setMessage(null);
    try {
      const n = action === 'suppr' ? await supprimerProduits(refs) : await remettreDisponibles(refs);
      await rafraichir();
      setMessage(action === 'suppr' ? '🗑️ ' + n + ' produit(s) supprimé(s) du catalogue.' : '↩️ ' + n + ' produit(s) remis disponible(s).');
    } catch (e) { setMessage('❌ Erreur : ' + e.message); }
    setOccupe(false);
  };
  // Recherche manuelle d'un produit mihi.care (noms trop différents pour être devinés)
  const resultatsRef = () => {
    if (!analyse) return [];
    const mots = jetonsNom(rechercheRef);
    if (rechercheRef.trim().length < 2 || !mots.length) return [];
    return analyse.paquet.produits.filter((p) => { const jn = jetonsNom(p.n); return mots.every((m) => jn.some((x) => x.includes(m))); }).slice(0, 6);
  };
  const changerUne = async (a, p) => {
    const existe = Object.values(analyse.actuel).some((l) => Array.isArray(l) && l.some((it) => it && it.ref != null && sansZeros(it.ref) === sansZeros(p.r)));
    setOccupe(true); setMessage(null);
    try {
      const n = await changerReferences([{ ancienne: a.ref, nouvelle: p.r, doublon: existe }]);
      await rafraichir(); setRefEnCours(''); setRechercheRef('');
      setMessage(n ? '🔁 Référence changée : « ' + String(a.nom) + ' » a maintenant la réf. ' + sansZeros(p.r) + '. Ta fiche est gardée.' : 'Rien n\'a été changé.');
    } catch (e) { setMessage('❌ Erreur : ' + e.message); }
    setOccupe(false);
  };
  const suggestions = enAnalyse ? proposerChangementsRef(rAnalyse) : [];
  const refCochee = (sg) => (cochesRef[sg.ancienne] === undefined ? sg.sure : cochesRef[sg.ancienne]);
  const nbRefs = suggestions.filter(refCochee).length;
  const changerRefs = async () => {
    const paires = suggestions.filter(refCochee);
    if (!paires.length) return;
    setOccupe(true); setMessage(null);
    try {
      const n = await changerReferences(paires);
      await rafraichir();
      setMessage('🔁 ' + n + ' référence(s) changée(s) : les fiches (photo, offres, packs) sont gardées, seules les références et les prix sont mis à jour. Vérifie le résumé ci-dessous.');
    } catch (e) { setMessage('❌ Erreur : ' + e.message); }
    setOccupe(false);
  };

  const annuler = async () => {
    setOccupe(true); setMessage(null);
    try {
      const b = await getDoc(doc(db, 'admin', 'catalogue_mihi_avant'));
      if (!b.exists()) throw new Error('Aucune sauvegarde trouvée.');
      await setDoc(doc(db, 'admin', 'catalogue_mihi'), b.data());
      setMessage("↩️ Le catalogue d'avant la dernière mise à jour est revenu.");
    } catch (e) { setMessage('❌ Erreur : ' + e.message); }
    setOccupe(false);
  };

  const copierCode = async () => {
    try { await navigator.clipboard.writeText(SCHEMA + RACCOURCI_CODE); setCodeCopie(true); setTimeout(() => setCodeCopie(false), 2500); } catch (e) { setMessage('Copie impossible : utilise plutôt le bouton à glisser dans ta barre de favoris.'); }
  };

  const bandeauAlerte = () => (
    alerte.length > 0 && (
        <div style={{ background: '#FFF3E0', border: '1.5px solid #E0A040', borderRadius: 10, padding: '.65rem .8rem', marginBottom: '.7rem' }}>
          <div style={{ fontSize: '.76rem', fontWeight: 700, color: '#8A5A00' }}>⚠️ {alerte.length} produit{alerte.length > 1 ? 's' : ''} de ton catalogue {enAnalyse ? (alerte.length > 1 ? "ne sont" : "n'est") : (alerte.length > 1 ? "n'étaient" : "n'était")} plus sur mihi.care {enAnalyse ? '' : 'à la dernière mise à jour'}</div>
          <div style={{ fontSize: '.68rem', color: C.texte, lineHeight: 1.55, marginTop: '.25rem' }}>
            Ils ont peut-être disparu, ou ils sont dans une catégorie que le favori ne lit pas. Tes clientes peuvent encore les commander dans ta boutique : vérifie-les.
          </div>
          <button onClick={() => setVoirAlerte((v) => !v)} style={{ marginTop: '.45rem', background: '#8A5A00', color: 'white', border: 'none', borderRadius: 8, padding: '.4rem .8rem', fontSize: '.72rem', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
            {voirAlerte ? 'Masquer la liste' : '👀 Voir et vérifier ces produits'}
          </button>
          {voirAlerte && (
            <div style={{ marginTop: '.55rem' }}>
              <div style={{ fontSize: '.66rem', color: C.gris, marginBottom: '.35rem', lineHeight: 1.5 }}>
                Cherche chaque produit sur mihi.care avec son <strong>nom</strong> ou sa <strong>référence</strong>. S'il a vraiment disparu, coche-le : il sera marqué <strong>indisponible</strong> dans ta boutique. Les autres restent comme ils sont.
              </div>
              <div style={{ maxHeight: 240, overflowY: 'auto', border: `1px solid ${C.pale}`, borderRadius: 8, background: C.blanc }}>
              {alerte.map((a) => (
                <div key={a.ref} style={{ borderBottom: `1px solid ${C.pale}` }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '.5rem', padding: '.35rem .55rem', fontSize: '.7rem', color: C.texte, cursor: 'pointer', background: coches[a.ref] ? '#FFF3E0' : 'transparent' }}>
                    <input type="checkbox" checked={!!coches[a.ref]} onChange={(e) => setCoches((c) => ({ ...c, [a.ref]: e.target.checked }))} />
                    <span style={{ flex: 1 }}>{String(a.nom == null ? '' : a.nom)}<span style={{ display: 'block', color: C.gris, fontSize: '.62rem' }}>réf. {String(a.ref)}{a.cat ? ' · ' + String(a.cat) : ''}</span></span>
                    <span style={{ whiteSpace: 'nowrap', color: C.gris }}>{a.prix ? fmt(a.prix) : ''}</span>
                  </label>
                  {enAnalyse && (
                    <div style={{ padding: '0 .55rem .4rem 1.75rem' }}>
                      <button onClick={() => { setRefEnCours(refEnCours === a.ref ? '' : a.ref); setRechercheRef(''); }} style={{ background: 'transparent', border: '1px solid #7FB5B5', color: '#1F5F5F', borderRadius: 8, padding: '.2rem .55rem', fontSize: '.64rem', cursor: 'pointer', fontFamily: 'inherit' }}>
                        🔁 Il a juste changé de référence ?
                      </button>
                      {refEnCours === a.ref && (
                        <div style={{ marginTop: '.35rem' }}>
                          <input value={rechercheRef} onChange={(e) => setRechercheRef(e.target.value)} placeholder="Cherche le produit sur mihi.care par son nom…" autoFocus
                            style={{ width: '100%', boxSizing: 'border-box', border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.35rem .55rem', fontSize: '.7rem', fontFamily: 'inherit', color: C.texte, background: C.creme, outline: 'none' }} />
                          {resultatsRef().map((p) => (
                            <button key={p.r} disabled={occupe} onClick={() => changerUne(a, p)} style={{ display: 'flex', justifyContent: 'space-between', gap: '.5rem', width: '100%', textAlign: 'left', marginTop: '.25rem', background: C.blanc, border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.3rem .5rem', fontSize: '.68rem', color: C.texte, cursor: 'pointer', fontFamily: 'inherit' }}>
                              <span>{String(p.n == null ? '' : p.n)}<span style={{ color: C.gris }}> · réf. {String(sansZeros(p.r))}</span></span>
                              <span style={{ color: C.gris, whiteSpace: 'nowrap' }}>{fmt(Number(p.p))}</span>
                            </button>
                          ))}
                          {rechercheRef.trim().length >= 2 && resultatsRef().length === 0 && <div style={{ fontSize: '.64rem', color: C.gris, marginTop: '.25rem' }}>Aucun produit trouvé avec ce nom.</div>}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                ))}
              </div>
              <div style={{ display: 'flex', gap: '.4rem', flexWrap: 'wrap', marginTop: '.45rem' }}>
                <button onClick={() => setCoches(Object.fromEntries(alerte.map((a) => [a.ref, true])))} style={{ background: 'transparent', border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.35rem .7rem', fontSize: '.68rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>Tout cocher</button>
                <button onClick={() => setCoches({})} style={{ background: 'transparent', border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.35rem .7rem', fontSize: '.68rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>Tout décocher</button>
                {!enAnalyse && <button onClick={() => retirerDeLAlerte(alerte.map((a) => a.ref))} disabled={occupe} style={{ background: 'transparent', border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.35rem .7rem', fontSize: '.68rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>✔️ Je les ai vérifiés, ne plus m'alerter</button>}
              </div>
              <button onClick={marquerCoches} disabled={occupe || nbCoches === 0} style={{ ...bouton(!occupe && nbCoches > 0, '#B26A00'), marginTop: '.5rem' }}>
                {occupe ? '⏳…' : '🚫 Marquer indisponibles (' + nbCoches + ')'}
              </button>
              {confirmer === 'alerte' ? (
                <div style={{ marginTop: '.4rem', display: 'flex', gap: '.4rem' }}>
                  <button onClick={supprimerCoches} disabled={occupe || nbCoches === 0} style={{ ...bouton(!occupe && nbCoches > 0, '#B04040'), flex: 1 }}>Oui, supprimer {nbCoches} produit{nbCoches > 1 ? 's' : ''}</button>
                  <button onClick={() => setConfirmer('')} style={{ background: 'transparent', border: `1px solid ${C.pale}`, borderRadius: 9, padding: '.4rem .8rem', fontSize: '.72rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>Non</button>
                </div>
              ) : (
                <button onClick={() => setConfirmer('alerte')} disabled={occupe || nbCoches === 0} style={{ ...bouton(!occupe && nbCoches > 0, '#8B1A1A'), marginTop: '.4rem' }}>
                  🗑️ Supprimer du catalogue ({nbCoches})
                </button>
              )}
              <div style={{ fontSize: '.62rem', color: C.gris, marginTop: '.3rem', textAlign: 'center' }}>« Indisponible » garde la fiche (on peut la remettre) · « Supprimer » l'enlève du catalogue. Dans les deux cas, tu peux annuler juste après.</div>
            </div>
          )}
        </div>
      ));

  const blocReferences = () => (
    suggestions.length > 0 && (
      <div style={{ background: '#EAF4F4', border: '1.5px solid #7FB5B5', borderRadius: 10, padding: '.65rem .8rem', marginBottom: '.7rem' }}>
        <div style={{ fontSize: '.76rem', fontWeight: 700, color: '#1F5F5F' }}>🔁 {suggestions.length} changement{suggestions.length > 1 ? 's' : ''} de référence probable{suggestions.length > 1 ? 's' : ''}</div>
        <div style={{ fontSize: '.68rem', color: C.texte, lineHeight: 1.55, marginTop: '.25rem' }}>
          Un produit disparu ressemble à un « nouveau » produit : c'est peut-être le même, avec une nouvelle référence. Coche ceux qui sont bien les mêmes : on garde ta fiche (photo, offres, packs) et on change <strong>seulement la référence</strong> (et le prix). Sans ça, l'ancien reste « disparu » et le nouveau est ajouté en double.
        </div>
        <div style={{ maxHeight: 220, overflowY: 'auto', border: `1px solid ${C.pale}`, borderRadius: 8, background: C.blanc, marginTop: '.45rem' }}>
          {suggestions.map((sg) => (
            <label key={sg.ancienne} style={{ display: 'flex', alignItems: 'center', gap: '.5rem', padding: '.4rem .55rem', borderBottom: `1px solid ${C.pale}`, fontSize: '.68rem', color: C.texte, cursor: 'pointer', background: refCochee(sg) ? '#EAF4F4' : 'transparent' }}>
              <input type="checkbox" checked={refCochee(sg)} onChange={(e) => setCochesRef((c) => ({ ...c, [sg.ancienne]: e.target.checked }))} />
              <span style={{ flex: 1 }}>
                {String(sg.nomAncien == null ? '' : sg.nomAncien)}<span style={{ color: C.gris }}> (réf. {String(sg.ancienne)})</span>
                <span style={{ display: 'block', color: '#1F5F5F' }}>→ {String(sg.nomNouveau == null ? '' : sg.nomNouveau)} <span style={{ color: C.gris }}>(réf. {String(sg.nouvelle)}){sg.sure ? ' · même nom' : ' · nom proche, à vérifier'}{sg.doublon ? ' · déjà ajouté en double : les deux fiches seront fusionnées' : ''}</span></span>
              </span>
              <span style={{ whiteSpace: 'nowrap', color: C.gris }}>{sg.prixAncien ? fmt(sg.prixAncien) : ''}{sg.prixNouveau ? ' → ' + fmt(sg.prixNouveau) : ''}</span>
            </label>
          ))}
        </div>
        <button onClick={changerRefs} disabled={occupe || nbRefs === 0} style={{ ...bouton(!occupe && nbRefs > 0, '#1F5F5F'), marginTop: '.5rem' }}>
          {occupe ? '⏳…' : '🔁 Changer seulement la référence (' + nbRefs + ')'}
        </button>
      </div>
    )
  );

  const blocRetires = () => (
    retires.length > 0 && (
      <div style={{ background: '#F4F0EE', border: `1px solid ${C.pale}`, borderRadius: 10, padding: '.6rem .8rem', marginTop: '.8rem' }}>
        <div style={{ fontSize: '.74rem', fontWeight: 700, color: C.brun }}>🚫 {retires.length} produit{retires.length > 1 ? 's' : ''} marqué{retires.length > 1 ? 's' : ''} indisponible{retires.length > 1 ? 's' : ''} (absents de mihi.care)</div>
        <button onClick={() => setVoirRetires((v) => !v)} style={{ marginTop: '.4rem', background: C.brun, color: 'white', border: 'none', borderRadius: 8, padding: '.38rem .8rem', fontSize: '.7rem', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
          {voirRetires ? 'Masquer la liste' : '👀 Voir la liste pour les supprimer'}
        </button>
        {voirRetires && (
          <div style={{ marginTop: '.5rem' }}>
            <div style={{ maxHeight: 240, overflowY: 'auto', border: `1px solid ${C.pale}`, borderRadius: 8, background: C.blanc }}>
              {retires.map((a) => (
                <label key={a.ref} style={{ display: 'flex', alignItems: 'center', gap: '.5rem', padding: '.35rem .55rem', borderBottom: `1px solid ${C.pale}`, fontSize: '.7rem', color: C.texte, cursor: 'pointer', background: cochesR[a.ref] ? '#F4F0EE' : 'transparent' }}>
                  <input type="checkbox" checked={!!cochesR[a.ref]} onChange={(e) => setCochesR((c) => ({ ...c, [a.ref]: e.target.checked }))} />
                  <span style={{ flex: 1 }}>{String(a.nom == null ? '' : a.nom)}<span style={{ display: 'block', color: C.gris, fontSize: '.62rem' }}>réf. {String(a.ref)}{a.cat ? ' · ' + String(a.cat) : ''}</span></span>
                  <span style={{ whiteSpace: 'nowrap', color: C.gris }}>{a.prix ? fmt(a.prix) : ''}</span>
                </label>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '.4rem', flexWrap: 'wrap', marginTop: '.45rem' }}>
              <button onClick={() => setCochesR(Object.fromEntries(retires.map((a) => [a.ref, true])))} style={{ background: 'transparent', border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.35rem .7rem', fontSize: '.68rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>Tout cocher</button>
              <button onClick={() => setCochesR({})} style={{ background: 'transparent', border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.35rem .7rem', fontSize: '.68rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>Tout décocher</button>
              <button onClick={() => agirSurRetires('remettre')} disabled={occupe || !retires.some((a) => cochesR[a.ref])} style={{ background: 'transparent', border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.35rem .7rem', fontSize: '.68rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>↩️ Remettre disponibles</button>
            </div>
            {confirmer === 'retires' ? (
              <div style={{ marginTop: '.4rem', display: 'flex', gap: '.4rem' }}>
                <button onClick={() => agirSurRetires('suppr')} disabled={occupe} style={{ ...bouton(!occupe, '#B04040'), flex: 1 }}>Oui, supprimer {retires.filter((a) => cochesR[a.ref]).length} produit(s)</button>
                <button onClick={() => setConfirmer('')} style={{ background: 'transparent', border: `1px solid ${C.pale}`, borderRadius: 9, padding: '.4rem .8rem', fontSize: '.72rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>Non</button>
              </div>
            ) : (
              <button onClick={() => setConfirmer('retires')} disabled={occupe || !retires.some((a) => cochesR[a.ref])} style={{ ...bouton(!occupe && retires.some((a) => cochesR[a.ref]), '#8B1A1A'), marginTop: '.4rem' }}>
                🗑️ Supprimer du catalogue ({retires.filter((a) => cochesR[a.ref]).length})
              </button>
            )}
          </div>
        )}
      </div>
    )
  );

  const r = resultat && resultat.rapport;
  const dateMaj = derniere && derniere.date ? new Date(derniere.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) : null;

  return (
    <div style={compact ? { marginTop: '.2rem' } : boite}>
      {!compact && <div style={titre}>🔄 Mise à jour depuis mihi.care</div>}
      {!compact && <p style={{ fontSize: '.72rem', color: C.gris, marginBottom: '.6rem', lineHeight: 1.6 }}>
        Récupère les prix catalogue, les prix VIP et les nouveautés directement depuis mihi.care, <strong>sans jamais donner ton mot de passe</strong> :
        le raccourci travaille dans ton navigateur, sur ta session déjà connectée.
        {dateMaj ? <> Dernière mise à jour : <strong>{dateMaj}</strong>.</> : null}
      </p>}
      {compact && dateMaj && <div style={{ fontSize: '.68rem', color: C.gris, marginBottom: '.4rem' }}>Dernière mise à jour du catalogue : <strong>{dateMaj}</strong>.</div>}

      {!compact && <div style={{ background: C.creme, borderRadius: 8, padding: '.6rem .75rem', marginBottom: '.7rem', fontSize: '.72rem', color: C.texte, lineHeight: 1.7 }}>
        <div><strong>Une seule fois :</strong> fais glisser ce bouton dans ta barre de favoris (Ctrl+Maj+B pour l'afficher).</div>
        <div style={{ margin: '.45rem 0' }}>
          <a ref={lienRef} href="#maj" onClick={(e) => e.preventDefault()} draggable="true"
            style={{ display: 'inline-block', background: C.brun, color: 'white', borderRadius: 20, padding: '.35rem .9rem', fontSize: '.74rem', fontWeight: 700, textDecoration: 'none', cursor: 'grab' }}>
            ⭐ Lire le catalogue Mihi
          </a>
          <button onClick={copierCode} style={{ marginLeft: '.6rem', background: 'transparent', border: `1px solid ${C.pale}`, borderRadius: 20, padding: '.3rem .7rem', fontSize: '.68rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>
            {codeCopie ? '✅ Code copié' : 'Le glisser ne marche pas ? Copier le code'}
          </button>
        </div>
        <div><strong>À chaque mise à jour :</strong> ① va sur mihi.care (connectée) ② clique sur le favori « Lire le catalogue Mihi » ③ « Copier » ④ colle ci-dessous.</div>
        <div style={{ color: C.gris, fontSize: '.66rem', marginTop: '.3rem' }}>Si tu as copié le code : crée un favori, et colle ce code à la place de l'adresse. Si le favori ne réagit pas, ouvre la console du navigateur (F12) sur mihi.care et colle le code (sans le « javascript: » du début).</div>
      </div>}

      {!analyse && bandeauAlerte()}

      <textarea value={texte} onChange={(e) => { setTexte(e.target.value); setAnalyse(null); }} placeholder="Colle ici ce que le raccourci a copié sur mihi.care"
        style={{ width: '100%', height: 70, boxSizing: 'border-box', border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.5rem', fontSize: '.7rem', fontFamily: 'monospace', color: C.texte, background: C.creme, outline: 'none', marginBottom: '.5rem' }} />
      <button onClick={analyser} disabled={occupe || !texte.trim()} style={bouton(!occupe && !!texte.trim())}>
        {occupe && !analyse ? '⏳ Analyse…' : '🔍 Voir ce qui va changer'}
      </button>

      {message && <div style={{ marginTop: '.6rem', fontSize: '.74rem', fontWeight: 600, color: message.startsWith('❌') ? '#B04040' : C.vert }}>{message}</div>}

      {blocRetires()}

      {r && (
        <div style={{ marginTop: '.7rem' }}>
          <div style={{ background: C.creme, borderRadius: 8, padding: '.6rem .75rem', fontSize: '.72rem', color: C.texte, lineHeight: 1.7 }}>
            <div><strong>{r.total}</strong> produits lus sur mihi.care</div>
            <div>✏️ <strong>{r.modifies.length}</strong> prix ou statuts à mettre à jour · ✔️ {r.inchanges} déjà à jour</div>
            {avecSc && <div>🗂️ Sous-catégories lues : elles seront enregistrées pour la boutique</div>}
            <div>🆕 <strong>{r.nouveaux.length}</strong> nouveau(x) produit(s){r.horsCategorie.length ? ' · ' + r.horsCategorie.length + ' accessoires/offres club non ajoutés' : ''}</div>
          </div>
          <div style={{ marginTop: '.6rem' }}>{blocReferences()}{bandeauAlerte()}</div>

          {r.modifies.length > 0 && (
            <div style={{ marginTop: '.5rem', maxHeight: 190, overflowY: 'auto', border: `1px solid ${C.pale}`, borderRadius: 8 }}>
              {r.modifies.slice(0, 60).map((m) => (
                <div key={m.ref} style={{ display: 'flex', justifyContent: 'space-between', gap: '.5rem', padding: '.3rem .6rem', fontSize: '.68rem', borderBottom: `1px solid ${C.pale}`, color: C.texte }}>
                  <span style={{ flex: 1 }}>{m.gros ? '⚠️ ' : ''}{String(m.nom == null ? '' : m.nom)}</span>
                  <span style={{ whiteSpace: 'nowrap' }}>{fmt(m.avant)} → <strong>{fmt(m.apres)}</strong></span>
                </div>
              ))}
              {r.modifies.length > 60 && <div style={{ padding: '.3rem .6rem', fontSize: '.66rem', color: C.gris }}>… et {r.modifies.length - 60} autres</div>}
            </div>
          )}

          {r.nouveaux.length > 0 && (
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: '.45rem', marginTop: '.55rem', fontSize: '.72rem', color: C.brun, fontWeight: 600, cursor: 'pointer' }}>
              <input type="checkbox" checked={ajouter} onChange={(e) => setAjouter(e.target.checked)} style={{ marginTop: 3 }} />
              <span>Ajouter les {r.nouveaux.length} nouveaux produits<span style={{ display: 'block', fontWeight: 400, color: C.gris, fontSize: '.66rem' }}>{r.nouveaux.slice(0, 5).map((n) => n.nom).join(' · ')}{r.nouveaux.length > 5 ? ' …' : ''}</span></span>
            </label>
          )}

          <button onClick={appliquer} disabled={occupe || (r.modifies.length === 0 && !(ajouter && r.nouveaux.length) && !avecSc)} style={{ ...bouton(!occupe && (r.modifies.length > 0 || (ajouter && r.nouveaux.length > 0) || avecSc), C.vert), marginTop: '.6rem' }}>
            {occupe ? '⏳ Mise à jour…' : '✅ Appliquer la mise à jour'}
          </button>
          <div style={{ fontSize: '.64rem', color: C.gris, marginTop: '.3rem', textAlign: 'center' }}>Une copie de l'ancien catalogue est gardée : tu peux annuler juste après.</div>
        </div>
      )}

      {peutAnnuler && !r && (
        <button onClick={annuler} disabled={occupe} style={{ marginTop: '.7rem', background: 'transparent', border: `1px solid ${C.pale}`, borderRadius: 9, padding: '.4rem .8rem', fontSize: '.7rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>
          ↩️ Annuler la dernière mise à jour
        </button>
      )}
    </div>
  );
}
